import { render, staticRenderFns } from "./stock-gold.vue?vue&type=template&id=a2f85312&scoped=true"
import script from "./stock-gold.vue?vue&type=script&lang=js"
export * from "./stock-gold.vue?vue&type=script&lang=js"
import style0 from "./stock-gold.vue?vue&type=style&index=0&id=a2f85312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f85312",
  null
  
)

export default component.exports